import React from 'react';
import { Card, Pagination } from 'react-bootstrap';


class EvaluationResultModal extends React.Component {
    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.data !== nextProps.data) {
            return true;
        }
        return false;
    }

    searchForm = () => {
        this.props.searchForm('', '', ((this.props.currentPage - 1) * this.props.limit), this.props.limit)
    }

    checkStatus = (status) => {
        switch (status) {
            case 1: {
                return (
                    <span className='badge badge-sm badge-success'>รายงานเรียบร้อย</span>
                );
            }
            case 2: {
                return (
                    <span className='badge badge-sm badge-danger'>ยังไม่รายงาน</span>
                );
            }
            case 3: {
                return (
                    <span className='badge badge-sm badge-warning'>รอการอนุมัติ</span>
                );
            }
            case 4: {
                return (
                    <span className='badge badge-sm badge-rejected'>รายงานไม่เรียบร้อย</span>
                );
            }
            default: return null;
        }
    }

    renderData = (data) => {
        return data.map((obj, index) => {
            if (index >= this.props.limit || obj === undefined) return false;
            return (
                <tr key={index}>
                    <td>{((this.props.currentPage - 1) * this.props.limit) + (index + 1)}</td>
                    <td>{parseInt(obj.Year) + 543}</td>
                    <td>{obj.KPIName}</td>
                    <td>{obj.EvaluationTypeName}</td>
                    <td align='center'>{this.checkStatus(obj.Status)}</td>
                    <td align="center">
                        <button onClick={() => this.props.changeCurrentKPIID(obj.KPIID)} className='btn btn-sm btn-outline-secondary mr-1'>
                            <i className='fa fa-pencil'></i>
                        </button>
                    </td>
                </tr>
            );
        })
    }

    showCurrentItem = () => {
        var number = ((this.props.currentPage - 1) * this.props.limit) + 1;
        var numberlast = (number + this.props.limit) - 1;
        if (numberlast > this.props.dataCount) numberlast = this.props.dataCount;
        if (this.props.dataCount === 0) {
            number = '0';
            numberlast = '0';
        }
        return (
            <div style={{ display: 'inline-block' }}>
                {'รายการที่แสดง : ' + number + ' - ' + numberlast + ' จาก ' + this.props.dataCount + ' รายการ'}
            </div>
        );
    }

    changeCurrentpage = (index) => {
        var pagenum = Math.floor(this.props.dataCount / this.props.limit) + 1;
        if (this.props.dataCount % this.props.limit === 0) pagenum -= 1;
        if (index === 0 || index > pagenum || index === this.props.currentPage) return
        this.props.onChangeTableState('currentPage', index);
    }

    createPagination = () => {
        var item = [];
        console.log(this.props.dataCount)
        var pagenum = Math.floor(this.props.dataCount / this.props.limit) + 1;
        console.log(pagenum)
        if (this.props.dataCount % this.props.limit === 0) pagenum -= 1;
        if (this.props.currentPage !== 1) {
            item.push(
                <React.Fragment key='PageStart'>
                    <Pagination.First onClick={() => { this.changeCurrentpage(1) }} />
                    <Pagination.Prev onClick={() => { this.changeCurrentpage(this.props.currentPage - 1) }} />
                </React.Fragment>
            );
            if (this.props.currentPage > 3) {
                item.push(
                    <Pagination.Ellipsis key={'ellipsisStart'} />
                );
            }
        }
        for (let i = 1; i <= pagenum; i++) {
            console.log(this.props.currentPage)
            if (i >= this.props.currentPage - 2)
                item.push(
                    <Pagination.Item key={i} active={i === this.props.currentPage} onClick={() => { this.changeCurrentpage(i) }}>
                        {i}
                    </Pagination.Item>
                );
            if (i === this.props.currentPage + 2) {
                item.push(<Pagination.Ellipsis key={'ellipsisEnd'} />);
                break;
            }
        }
        if (pagenum !== 1 && pagenum !== this.props.currentPage)
            item.push(
                <React.Fragment key={'PageEnd'}>
                    <Pagination.Next onClick={() => { this.changeCurrentpage(this.props.currentPage + 1) }} />
                    <Pagination.Last onClick={() => { this.changeCurrentpage(pagenum) }} />
                </React.Fragment>
            );
        return item;
    }

    changeLimit = (e) => {
        var newLimit = parseInt(e.target.value);
        var oldLimit = this.props.limit;
        var newCurrentPage = Math.floor(((this.props.currentPage - 1) * oldLimit) / newLimit) + 1;
        this.props.onChangeTableState('', newCurrentPage, newLimit);
    }

    renderSearched = (searched) => {
        var el = [];
        if (searched.searchedYear !== 0) {
            el.push(
                <div className='search-pill' key='EvaluationManage-searched1'>
                    ปีงบประมาณ : {searched.searchedYear + 543}
                </div>
            );
        }
        if (searched.searchedEvaluationTypeID !== 0) {
            el.push(
                <div className='search-pill' key='EvaluationManage-searched2'>
                    ประเภทการประเมิน: {this.props.checkEvaluationType(searched.searchedEvaluationTypeID)}
                </div>
            );
        }
        if (searched.searchedOrganization.OrganizationID !== undefined) {
            el.push(
                <div className='search-pill' key='EvaluationManage-searched3'>
                    หน่วยงาน: {searched.searchedOrganization.OrganizationName}
                </div>
            );
        }
        if (searched.searchedPerson.PersonID !== undefined) {
            el.push(
                <div className='search-pill' key='EvaluationManage-searched4'>
                    บุคคล: {searched.searchedPerson.PersonName}
                </div>
            );
        }
        if (searched.searchedStatus !== 0) {
            var text;
            if (searched.searchedStatus === 1) {
                text = 'รายงานเรียบร้อย'
            }
            else if (searched.searchedStatus === 2) {
                text = 'ยังไม่รายงาน'
            }
            else if (searched.searchedStatus === 3) {
                text = 'รอการอนุมัติ'
            }
            else {
                text = 'รายงานไม่เรียบร้อย'
            }
            el.push(
                <div className='search-pill' key='EvaluationManage-searched5'>
                    สถานะ: {text}
                </div>
            );
        }
        return el;
    }

    render() {
        return (
            <>
                {
                    (this.props.searched.isSearched !== false) ?
                        <div>
                            ผลการค้นหา : {this.renderSearched(this.props.searched)}
                        </div>
                        : null
                }
                <Card className="card-custom-table">
                    <Card.Header>
                        <div className="float-right">
                            <div className="d-inline-block mr-1">แสดง </div>
                            <select className="form-control d-inline-block" onChange={this.changeLimit} style={{ width: '75px' }}>
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={20}>20</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <div className="d-inline-block ml-1">รายการ</div>
                        </div>
                    </Card.Header>
                    <Card.Body className='table-responsive-xl mb-2'>
                        <table className="table mb-0 table-custom table-striped table-bordered table-hover">
                            <thead>
                                <tr align='center'>
                                    <th style={{ minWidth: '60px' }}>ลำดับ</th>
                                    <th style={{ minWidth: '75px' }}>ปีงบประมาณ</th>
                                    <th style={{ minWidth: '175px' }}>ชื่อตัวชี้วัด</th>
                                    <th style={{ minWidth: '150px' }}>การประเมิน</th>
                                    <th style={{ minWidth: '70px' }}>สถานะ</th>
                                    <th style={{ minWidth: '75px' }}>แก้ไข</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderData(this.props.data)}
                            </tbody>
                        </table>
                    </Card.Body>
                    <Card.Footer>
                        {this.showCurrentItem()}
                        <Pagination className="mb-0 float-right">
                            {this.createPagination()}
                        </Pagination>
                    </Card.Footer>
                </Card>
            </>
        );
    }
}

export default EvaluationResultModal;